import { type SrIconName } from '@/components/ui/SrIcon';
import { type MenuKey } from '@/hooks/use-menu-permissions';
import { NAV_CONFIG, NAV_TOP_LEVEL_KEYS } from '@/lib/menu-registry';

export interface NavItem {
  path: string;
  label: string;
  icon: SrIconName;
  // null/undefined = always visible (e.g., logout-aktig). Ellers gates via
  // role_menu_permissions-tabellen via useMenuPermissions().
  menuKey?: MenuKey;
  /** Hvis satt rendres item som collapsible group i sidebaren. */
  children?: NavItem[];
  /** Tall ved siden av menyvalget, f.eks. uleste i Chat (VIB-3022). 0 skjules. */
  badge?: number;
}

// VIB-1179: NAV_CONFIG og TOP_LEVEL_KEYS avledes nå fra det sentrale
// menyregisteret (src/lib/menu-registry.ts), så sidebaren ikke kan drive fra
// de andre menyflatene. Rekkefølge per rolle styres fortsatt dynamisk av
// role_menu_permissions.sort_order i rendringen.
export { NAV_CONFIG };
export const TOP_LEVEL_KEYS: MenuKey[] = NAV_TOP_LEVEL_KEYS;

/**
 * Aktiv underside i en gruppe: eksakt treff, eller en under-rute (f.eks.
 * /salgsmuligheter/pipe under «Oppdag og pipe») som ikke eies av et søsken.
 */
export function isNavChildActive(child: NavItem, siblings: NavItem[], pathname: string): boolean {
  if (pathname === child.path) return true;
  if (!pathname.startsWith(`${child.path}/`)) return false;
  return !siblings.some(
    (o) => o !== child && (pathname === o.path || pathname.startsWith(`${o.path}/`)) && o.path.length > child.path.length,
  );
}
